import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { CreditCard, Wallet, QrCode, Building2 } from 'lucide-react';

const PROMPTPAY_QR = "https://customer-assets.emergentagent.com/job_carib-table-pay/artifacts/jopor950_PHOTO-2026-04-06-21-01-53.jpg";

const PaymentMethodSelector = ({ isOpen, onClose, onSelect, billAmount, formatPrice }) => {
  const methods = [
    { id: 'stripe', label: 'Carte / Apple Pay / Google Pay', icon: CreditCard, color: 'bg-[#D4A853]', textColor: 'text-black' },
    { id: 'promptpay', label: 'PromptPay (QR)', icon: QrCode, color: 'bg-[#1B3A4B]', textColor: 'text-white' },
    { id: 'counter', label: 'Paiement au comptoir', icon: Building2, color: 'bg-[#0A422D]', textColor: 'text-white' },
  ];

  const [selectedMethod, setSelectedMethod] = React.useState(null);
  const [showQR, setShowQR] = React.useState(false);

  const handleSelect = (methodId) => {
    if (methodId === 'promptpay') {
      setSelectedMethod('promptpay');
      setShowQR(true);
    } else if (methodId === 'counter') {
      setSelectedMethod('counter');
    } else {
      onSelect(methodId);
    }
  };

  const handleConfirm = () => {
    onSelect(selectedMethod);
  };

  const handleClose = () => {
    setSelectedMethod(null);
    setShowQR(false);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) handleClose(); }}>
      <DialogContent className="max-w-sm bg-[#0D0D0D] border border-[#333333] rounded-3xl p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="text-white text-lg">
            {showQR ? 'Scanner pour payer' : selectedMethod === 'counter' ? 'Paiement au comptoir' : 'Mode de paiement'}
          </DialogTitle>
        </DialogHeader>

        <div className="px-6 pb-6">
          {!selectedMethod && (
            <div className="space-y-3">
              <p className="text-[#A0A0A0] text-sm mb-4">
                Total: <span className="text-[#D4A853] font-bold text-base">{formatPrice(billAmount)}</span>
              </p>
              {methods.map(method => (
                <button
                  key={method.id}
                  onClick={() => handleSelect(method.id)}
                  className={`w-full flex items-center gap-4 p-4 rounded-2xl ${method.color} ${method.textColor} font-semibold text-sm transition-transform active:scale-[0.98]`}
                  data-testid={`payment-method-${method.id}`}
                >
                  <method.icon className="w-6 h-6" />
                  <span>{method.label}</span>
                </button>
              ))}
            </div>
          )}

          {showQR && (
            <div className="text-center space-y-4">
              <p className="text-[#A0A0A0] text-sm">
                Montant: <span className="text-[#D4A853] font-bold text-lg">{formatPrice(billAmount)}</span>
              </p>
              <div className="bg-white rounded-2xl p-4 inline-block mx-auto">
                <img
                  src={PROMPTPAY_QR}
                  alt="PromptPay QR Code"
                  className="w-56 h-56 object-contain mx-auto"
                  data-testid="promptpay-qr-image"
                />
              </div>
              <p className="text-[#A0A0A0] text-xs">
                Scannez ce QR code avec votre application bancaire thailandaise
              </p>
              <button
                onClick={handleConfirm}
                className="w-full py-3 rounded-full bg-[#2D6A4F] text-white font-semibold text-sm transition-all hover:bg-[#245A42]"
                data-testid="promptpay-done-btn"
              >
                J'ai paye via PromptPay
              </button>
              <button
                onClick={() => { setSelectedMethod(null); setShowQR(false); }}
                className="text-[#A0A0A0] text-xs underline"
              >
                Retour
              </button>
            </div>
          )}

          {selectedMethod === 'counter' && (
            <div className="text-center space-y-4">
              <div className="w-20 h-20 bg-[#0A422D] rounded-full flex items-center justify-center mx-auto">
                <Building2 className="w-10 h-10 text-white" />
              </div>
              <p className="text-white text-base font-semibold">
                Rendez-vous au comptoir
              </p>
              <p className="text-[#A0A0A0] text-sm">
                Presentez votre numero de table au comptoir pour regler votre addition de <span className="text-[#D4A853] font-bold">{formatPrice(billAmount)}</span>
              </p>
              <button
                onClick={handleConfirm}
                className="w-full py-3 rounded-full bg-[#0A422D] text-white font-semibold text-sm transition-all hover:bg-[#083323]"
                data-testid="counter-confirm-btn"
              >
                OK, j'y vais
              </button>
              <button
                onClick={() => setSelectedMethod(null)}
                className="text-[#A0A0A0] text-xs underline"
              >
                Retour
              </button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodSelector;
